import { render, staticRenderFns } from "./sample-manage.vue?vue&type=template&id=0c504874&scoped=true&"
import script from "./sample-manage.vue?vue&type=script&lang=js&"
export * from "./sample-manage.vue?vue&type=script&lang=js&"
import style0 from "./sample-manage.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./sample-manage.vue?vue&type=style&index=1&id=0c504874&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c504874",
  null
  
)

export default component.exports